var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHomeActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.461,
    height: 20,
    viewBox: "0 0 18.461 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-home",
    d: "M15.206,4a.769.769,0,0,0-.451.165L7.466,9.907A3.848,3.848,0,0,0,6,12.928v9.789A1.293,1.293,0,0,0,7.282,24H12.41a1.293,1.293,0,0,0,1.282-1.282V17.589a.245.245,0,0,1,.256-.256h2.564a.245.245,0,0,1,.256.256v5.128A1.293,1.293,0,0,0,18.051,24h5.128a1.293,1.293,0,0,0,1.282-1.282V12.928a3.848,3.848,0,0,0-1.466-3.021L15.706,4.165a.769.769,0,0,0-.5-.165Zm.025,1.749,6.813,5.367a2.3,2.3,0,0,1,.879,1.812v9.533H18.307V17.589a1.807,1.807,0,0,0-1.795-1.795H13.949a1.807,1.807,0,0,0-1.795,1.795v4.872H7.538V12.928a2.3,2.3,0,0,1,.879-1.812Z",
    transform: "translate(-6 -3.999)",
    fill: "#555b70"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeActive);
export default __webpack_public_path__ + "static/media/iconHomeActive.44ec606c45f56188d0533fee5fa3920b.svg";
export { ForwardRef as ReactComponent };